<template>
    <v-container fluid>
      <v-row align="center" justify="center">
        <v-col class="d-flex justify-center" cols="5">
          <p class="mt-3 mr-3">{{ $t('filters.prepend') }}</p>
          <SwisetSelect :options="periods" label="Periodo" :placeholder=this.$i18n.messages[this.$i18n.locale].filters.currentWeek :type="0" v-model="periodSelected" :changeEvent="periodChanged"></SwisetSelect>
          <p class="mt-3 mx-3">{{ $t('filters.and') }}</p>
          <SwisetSelect :allOption="true" :options="brokerAccounts.map(acc=>({value : acc.id, text:`${acc.identifier} - ${acc.broker.name}`}))" label="Broker Accounts" :placeholder=this.$i18n.messages[this.$i18n.locale].allBrokers :type="0" v-model="accountSelected" :changeEvent="brokerChanged"></SwisetSelect>
          <p class="mt-3 ml-3">{{ $tc('filters.append', (accountSelected === 'All')? 2 : 1) }}</p>
        </v-col>
      </v-row>
      
      <v-row class="mt-n3" align="center" justify="center">
        <v-col v-bind:key="ratio" v-for="ratio in ratios">
          <v-card :class="getRatioBorder(ratio)" elevation="5" outlined>
            <v-card-text>
              <h1 class="text-center" >{{ getRatio(ratio) }}</h1>
              <h3 class="text-center">{{ getRatioName(ratio) }}</h3>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-divider class="mt-6 mb-8"/>

      <v-row style="position: relative;">
        <div style="width: 100%">
          <h2 class="text-center my-5">
            {{ $t('insights.title') }} {{ accountBasicName }}
            <v-icon v-if="accountVerified" class="ml-1 mt-n1" color="blue" small>fa-check-circle</v-icon>
          </h2>
          <InsightsSummary v-blur="blurConfig" :insights="priorityInsights" :full="false"/>
          <v-overlay v-model="canSeeStat" absolute opacity="0">
            <v-btn class="button-convert" @click="overlayUpgradeToPro = true">{{ $t('btnCTA') }}
              <v-icon class="ml-2" small>fa-star</v-icon>
            </v-btn>
          </v-overlay>
        </div>
      </v-row>

      <v-overlay v-model="overlayUpgradeToPro">
        <UpgradeToPro :message="messageUpgradeToPro" @closeWindow="closeOverlayUpgradeToPro"/>
      </v-overlay>
    </v-container>
</template>

<script>
import Repository from '../../../repositories/journal';
import InsightsRepository from '../../../repositories/insights';
import InsightsData from '../../Mentor/insightsData';
import InsightsSummary from "@/views/Mentor/components/InsightsSummary";
import UpgradeToPro from "@/components/UpgradeToPro";
import SwisetSelect from '../../../components/comp-base/SwisetSelect.vue';
export default {
  name: "AnalyticsSummary",
  components: { UpgradeToPro, InsightsSummary, SwisetSelect },
  data() {
    return {
      // Cards
      analytics: null,
      periods: [
        { value: 'Current week', text: this.$t('filters.currentWeek') },
        { value: 'Current month', text: this.$t('filters.currentMonth') },
        { value: 'Last 30 days', text: this.$t('filters.last30days') },
        { value: 'Last 90 days', text: this.$t('filters.last90days') },
      ],
      periodSelected: 'Current week',
      brokerAccounts: [],
      accountSelected: 'All',
      ratios: [
        'Profit Factor',
        'Winning Ratio',
        'Swiset Ratio',
        'Risk/Reward Ratio',
        'Net Profit',
      ],

      // Insights
      allInsights: [],
      priorityInsights: {},
      blurConfig: {
        isBlurred: !this.$store.state.user.isPro,
        opacity: 0.1,
        filter: "blur(1.2px)",
        transition: "all .3s linear"
      },
      canSeeStat: !this.$store.state.user.isPro,
      messageUpgradeToPro: 'With pro you can get unlimited trading insights.',

      // Upgrade to pro
      overlayUpgradeToPro: false,
    };
  },
  computed: {
    accountBasicName() {
      if(this.accountSelected === 'All')
        return this.$t('allAccounts');
      let accountFound = this.$store.state.user.brokerAccounts.find((account) => account.id === Number(this.accountSelected));
      return (accountFound.identifier !== '')? `${accountFound.broker.name} · ${accountFound.identifier}` :  accountFound.broker.name;
    },
    accountVerified() {
      if(this.accountSelected === 'All')
        return false;
      let accountFound = this.$store.state.user.brokerAccounts.find((account) => account.id === Number(this.accountSelected));
      return accountFound.verified;
    },
  },
  watch: {
    '$store.state.user.brokerAccounts': function () {
      this.init();
    },
    '$store.state.user.isPro': function () {
      this.blurConfig = {
        isBlurred: !this.$store.state.user.isPro,
        opacity: 0.1,
        filter: "blur(1.2px)",
        transition: "all .3s linear"
      };
      this.canSeeStat = !this.$store.state.user.isPro;
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.$store.state.user.brokerAccounts.forEach((brokerAccount) => {
        this.brokerAccounts.push(brokerAccount);
      });

      // Dates
      let nowFilters = new Date();
      nowFilters.setDate(nowFilters.getDate() + 1);
      let fromFilters = new Date();
      fromFilters = new Date(fromFilters.getFullYear(), fromFilters.getMonth(), 1);

      let filter = {
        userId: this.$store.state.user.id,
        fromDate: new Date(fromFilters.getFullYear(), fromFilters.getMonth(), fromFilters.getDate(), 0, 0),
        toDate: new Date(nowFilters.getFullYear(), nowFilters.getMonth(), nowFilters.getDate(), 0, 0),
        side: 'All',
        mood: 'All',
        asset: 'All',
        brokerAccount: this.accountSelected,
        result: 'All',
        strategy: 'All',
      };

      Repository.analyticsSummary(filter).then((response) => {
        if(response.status < 400)
          this.analytics = response.data;
      });
      InsightsRepository.getUserInsights().then((response) => {
        this.allInsights = [];
        if(response.status < 400) {
          response.data.forEach((insight) => { this.allInsights.push(JSON.parse(insight)); });
        }
        this.setPriorityInsights();
      });
    },
    setPriorityInsights() {
      let partialInsights = (this.accountSelected === 'All')? this.allInsights.find((insightsData) => insightsData.id === -1) :
        this.allInsights.find((insightsData) => insightsData.id === Number(this.accountSelected));
      //let partialInsights = this.allInsights[this.allInsights.length - 1];
      for(let i = 0; i < partialInsights.brokerAccountInsights.length; i++) {
        let foundInsight = InsightsData.find((insightMaster) => insightMaster.insightType === partialInsights.brokerAccountInsights[i].insightType);
        if(foundInsight !== undefined)
          partialInsights.brokerAccountInsights[i].priority = foundInsight.priority;
      }
      partialInsights.brokerAccountInsights.sort((a, b ) => a.priority - b.priority);
      partialInsights.brokerAccountInsights = partialInsights.brokerAccountInsights.slice(0, 4);
      this.priorityInsights = partialInsights;
    },
    brokerChanged() {
      if(!this.accountSelected){
        this.accountSelected ="All";
      }
      this.periodChanged();
      this.setPriorityInsights();
    },
    periodChanged() {
      // Dates
      let nowFilters = new Date();
      nowFilters.setDate(nowFilters.getDate() + 1);
      let fromFilters = new Date();

      // Setting from time
      if(this.periodSelected === 'Current week')
        fromFilters.setDate(fromFilters.getDate() - (fromFilters.getDay() + 6) % 7); // set to Monday of this week
      else if(this.periodSelected === 'Current month')
        fromFilters = new Date(fromFilters.getFullYear(), fromFilters.getMonth(), 1);
      else {
        let minusTime = (this.periodSelected === 'Last 7 days') ? 6.048e+8 : (this.periodSelected === 'Last 30 days') ? 2.628e+9 : 7.884e+9;
        fromFilters.setTime((fromFilters.getTime() - minusTime));
      }

      let filter = {
        userId: this.$store.state.user.id,
        fromDate: new Date(fromFilters.getFullYear(), fromFilters.getMonth(), fromFilters.getDate(), 0, 0),
        toDate: new Date(nowFilters.getFullYear(), nowFilters.getMonth(), nowFilters.getDate(), 0, 0),
        side: 'All',
        mood: 'All',
        asset: 'All',
        brokerAccount: this.accountSelected,
        result: 'All',
        strategy: 'All',
      };

      Repository.analyticsSummary(filter).then((response) => {
        if(response.status < 400)
          this.analytics = response.data;
      });
    },
    getNumber(number) {
      return (number > 1000 || number < -1000)? `${(number/1000).toFixed(2)}k` : (number.toFixed(2) * 1).toString();
    },
    getRatioName(ratio) {
      if(this.analytics != null){
        switch (ratio) {
          case 'Profit Factor':
            return this.$t('ratios.profitFactor');
          case 'Winning Ratio':
            return this.$t('ratios.winning');
          case 'Swiset Ratio':
            return this.$t('ratios.swiset');
          case 'Risk/Reward Ratio':
            return this.$t('ratios.riskReward');
          case 'Net Profit':
            return this.$t('ratios.netProfit');
        }
      }
    },
    getRatio(ratio) {
      if(this.analytics != null){
        switch (ratio) {
          case 'Profit Factor':
            return this.analytics.profitFactor.toFixed(2);
          case 'Winning Ratio':
            return `${(this.analytics.winRate * 100).toFixed(1)}%`;
          case 'Swiset Ratio':
            return this.analytics.swisetRatio.toFixed(2);
          case 'Risk/Reward Ratio':
            return `1 : ${this.analytics.riskReward.toFixed(2)}`;
          case 'Net Profit':
            return this.getNumber(this.analytics.netProfit);
        }
      }
    },
    getRatioColor(ratio) {
      if(this.analytics != null){
        switch (ratio) {
          case 'Profit Factor':
            return (this.analytics.profitFactor > 1)? '#00a553' : '#f14400';
          case 'Winning Ratio':
            return '#111111';
          case 'Swiset Ratio':
            return (this.analytics.swisetRatio > 1)? '#00a553' : '#f14400';
          case 'Risk/Reward Ratio':
            return '#111111';
          case 'Net Profit':
            return (this.analytics.netProfit > 0)? '#00a553' : '#f14400';
        }
      }
    },
    getRatioBorder(ratio) {
      if(this.analytics != null){
        switch (ratio) {
          case 'Profit Factor':
            return (this.analytics.profitFactor > 1)? 'positive-border-box' : 'negative-border-box';
          case 'Winning Ratio':
            return 'neutral-border-box';
          case 'Swiset Ratio':
            return (this.analytics.swisetRatio > 1)? 'positive-border-box' : 'negative-border-box';
          case 'Risk/Reward Ratio':
            return 'neutral-border-box';
          case 'Net Profit':
            return (this.analytics.netProfit > 0)? 'positive-border-box' : 'negative-border-box';
        }
      }
    },
    closeOverlayUpgradeToPro() {
      this.overlayUpgradeToPro = false;
    },
  }
}
</script>

<i18n>
{
  "en": {
    "all": "All",
    "allBrokers":"All accounts",
    "greetings": {
      "prepend": "Hello",
      "append": " Welcome back!"
    },
    "filters": {
      "prepend": "Quick summary of",
      "and": "and",
      "append": "account | accounts",
      "currentWeek": "Current week",
      "currentMonth": "Current month",
      "last30days": "Last 30 days",
      "last90days": "Last 90 days"
    },
    "ratios": {
      "profitFactor": "Profit Factor",
      "winning": "Winning Ratio",
      "swiset": "Swiset Ratio",
      "riskReward": "Risk/Reward Ratio",
      "netProfit": "Net Profit"
    },
    "allAccounts": "All accounts",
    "insights": {
      "title": "Most Relevant Insights for"
    },
    "btnCTA": "Get Insights, by upgrading to Pro"
  },
  "es": {
    "all": "Todas",
    "allBrokers":"Todas las cuentas",
    "greetings": {
      "prepend": "Hola",
      "append": " ¡Bienvenido de nuevo!"
    },
    "filters": {
      "prepend": "Rápido resumen de",
      "and": "y",
      "append": "cuenta | cuentas",
      "currentWeek": "Semana actual",
      "currentMonth": "Mes actual",
      "last30days": "Últimos 30 días",
      "last90days": "Últimos 90 días"
    },
    "ratios": {
      "profitFactor": "Factor de Beneficio",
      "winning": "Ratio de Ganancia",
      "swiset": "Ratio Swiset",
      "riskReward": "Ratio Riesgo/Beneficio",
      "netProfit": "Beneficio Neto"
    },
    "allAccounts": "Todas las Cuentas",
    "insights": {
      "title": "Insights Más Relevantes para"
    },
    "btnCTA": "Obtén Insights, actualizándote a Pro"
  }
}
</i18n>

<style scoped>
.positive-border-box {
  border-top: 5px solid #00a553 !important;
}

.negative-border-box {
  border-top: 5px solid #f14400 !important;
}

.neutral-border-box {
  border-top: 5px solid #4e4e4e !important;
}

.button-convert {
  background-color: #fff75f !important;
  color: #111111 !important;
  border: #fff75f solid 1px;
}
</style>
